export const sideNavLinksAndSections = [
  {
    header: 'Organization settings',
    links: [
      {
        name: 'Organization',
        pathname: '/admin/newOrganization',
        hash: '#organization',
      },
      {
        name: 'Administrator',
        pathname: '/admin/newOrganization',
        hash: '#administrator',
      },
      {
        name: 'Project',
        pathname: '/admin/newOrganization',
        hash: '#project',
      },
    ],
  },
];
